module.exports = __webpack_public_path__ + "static/img/nm84_75.6d378f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/award_pieces/nm84_75.jpg
// module id = 200
// module chunks = 1